import React from 'react';
import { useStore } from '../context/StoreContext';
import SafeIcon from '../common/SafeIcon';
import { APP_VIEW_DASHBOARD, APP_VIEW_BOARD } from '../constants';

const TabletNavRail = ({ onMore }) => {
  const { viewMode, setViewMode, setIsPaletteOpen } = useStore();
  const items = [
    { id: 'home', label: 'Home', icon: 'Home', active: viewMode === APP_VIEW_DASHBOARD, action: () => setViewMode(APP_VIEW_DASHBOARD) },
    { id: 'notes', label: 'Notes', icon: 'FileText', active: [APP_VIEW_BOARD, 'list', 'timeline'].includes(viewMode), action: () => setViewMode(APP_VIEW_BOARD) },
    { id: 'capture', label: 'Capture', icon: 'Zap', action: () => window.dispatchEvent(new CustomEvent('stickyhq:open-quick-capture')) },
    { id: 'search', label: 'Search', icon: 'Search', action: () => setIsPaletteOpen(true) },
    { id: 'more', label: 'More', icon: 'Menu', action: onMore }
  ];

  return (
    <nav aria-label="Primary tablet navigation" className="w-[88px] shrink-0 border-r border-gray-200 bg-white/90 backdrop-blur-xl safe-top safe-bottom flex flex-col items-center py-3 gap-2">
      <div className="w-12 h-12 mb-2 rounded-2xl bg-amber-400 flex items-center justify-center text-gray-900 shadow-sm">
        <SafeIcon name="FileText" className="text-[24px]" />
      </div>
      {items.map(item => (
        <button
          key={item.id}
          type="button"
          onClick={item.action}
          className={`w-[72px] min-h-[64px] rounded-2xl flex flex-col items-center justify-center gap-1 transition active:scale-95 ${item.active ? 'bg-blue-50 text-blue-700' : 'text-gray-500 hover:bg-gray-50'}`}
          aria-label={item.label}
        >
          <SafeIcon name={item.icon} className="text-[25px]" />
          <span className="text-[11px] font-bold">{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default TabletNavRail;